/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Form_TitleInputs */

const en_support_form_title = /** @type {(inputs: Support_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send us a message`)
};

const id_support_form_title = /** @type {(inputs: Support_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim pesan ke kami`)
};

/**
* | output |
* | --- |
* | "Send us a message" |
*
* @param {Support_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_form_title = /** @type {((inputs?: Support_Form_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Form_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_form_title(inputs)
	return en_support_form_title(inputs)
});